import { render, staticRenderFns } from "./HealthRecordCard.vue?vue&type=template&id=5e5a72d8&scoped=true&"
import script from "./HealthRecordCard.vue?vue&type=script&lang=js&"
export * from "./HealthRecordCard.vue?vue&type=script&lang=js&"
import style0 from "./HealthRecordCard.vue?vue&type=style&index=0&id=5e5a72d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5a72d8",
  null
  
)

export default component.exports